import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";

export const RepairEstimateDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IRepairEstimate> {
  protected mapEntity(entity: IRepairEstimate): IRepairEstimate {
    return new RepairEstimate(entity);
  }

  getIdentifier(entity: IRepairEstimate): string {
    return entity.id;
  }
})();
